"use client";
import { useEligibilitystore } from "@/store/territoryStore";
import React, { useEffect, useState } from "react";

const Selection = (params: {
  data: any[];
  handleSelection: (data: string[]) => void;
  selected: string[];
  name: string;
}) => {
  const [keyword, setKeyword] = useState("");
  const [selection, setSelection] = useState<string[]>([]);
  const [data, setData] = useState(params.data);

  const filtered = data?.filter((i) =>
    i.name.toLowerCase().includes(keyword?.toLowerCase())
  );

  const checkChecked = (name: string) => selection.includes(name);

  useEffect(() => {
    if (params.data?.length > 0) setData(params.data);
  }, [params.data]);

  useEffect(() => {
    setSelection(params.selected);
  }, [params.selected]);

  return (
    <div className="flex flex-col gap-4 p-4 shadow-lg rounded-lg">
      <h5 className="capitalize font-bold">{params.name}</h5>
      <div className="flex items-center gap-4">
        <input
          type="text"
          value={keyword}
          className="input input-xs input-bordered w-full"
          placeholder={`Cari ${params.name} di sini...`}
          onChange={(e) => setKeyword(e.target.value)}
        />
      </div>
      <div className="flex flex-col cursor-pointer gap-2 max-h-[300px] overflow-y-auto">
        {filtered?.map((i) => (
          <label
            htmlFor={`${params.name}_${i.id}`}
            key={`${params.name}_${i.id}`}
            className="flex items-center gap-2"
          >
            <input
              id={`${params.name}_${i.id}`}
              type="checkbox"
              checked={checkChecked(i.name)}
              value={i.name}
              onChange={(e) => {
                const newSelection = e.target.checked
                  ? [...selection, i.name]
                  : selection.filter((j) => j !== i.name);
                params.handleSelection(newSelection);
              }}
              className="checkbox checkbox-primary checkbox-xs"
            />
            <span>{i.name}</span>
          </label>
        ))}
      </div>
    </div>
  );
};

type SelectionType = {
  areas: string[];
  regions: string[];
  branches: string[];
  clusters: string[];
  cities: string[];
};
const FormEligibilityTerritory = (params: {
  onChange: (data: SelectionType) => void;
  selected: SelectionType | null;
}) => {
  const status = useEligibilitystore((state) => state.status);
  const areas = useEligibilitystore((state) => state.areas);
  const regions = useEligibilitystore((state) => state.regions);
  const branches = useEligibilitystore((state) => state.branches);
  const clusters = useEligibilitystore((state) => state.clusters);
  const cities = useEligibilitystore((state) => state.cities);
  const get_all_territory = useEligibilitystore(
    (state) => state.get_all_territory
  );

  const [selection, setSelection] = useState<SelectionType>({
    areas: [] as string[],
    regions: [] as string[],
    branches: [] as string[],
    clusters: [] as string[],
    cities: [] as string[],
  });

  useEffect(() => {
    get_all_territory();
  }, []);

  useEffect(() => {
    params.onChange(selection);
  }, [selection]);

  useEffect(() => {
    if (params.selected) setSelection(params.selected);
  }, [params.selected]);

  const handleSelect = (
    type: "areas" | "regions" | "branches" | "clusters" | "cities",
    data: string[]
  ) => {
    const getIds = (list: any[], selectedNames: string[]) =>
      list.filter((i) => selectedNames.includes(i.name)).map((i) => i.id);

    const newSelection = {
      areas: type === "areas" ? data : selection.areas,
      regions: [] as string[],
      branches: [] as string[],
      clusters: [] as string[],
      cities: [] as string[],
    };

    const areaIds = getIds(areas!, newSelection.areas);
    const filteredRegions =
      regions?.filter((r) => areaIds.includes(r.area_id)) ?? [];
    newSelection.regions =
      type === "regions" ? data : filteredRegions.map((r) => r.name);

    const regionIds = getIds(regions!, newSelection.regions);
    const filteredBranches =
      branches?.filter((b) => regionIds.includes(b.region_id)) ?? [];
    newSelection.branches =
      type === "branches" ? data : filteredBranches.map((b) => b.name);

    const branchIds = getIds(branches!, newSelection.branches);
    const filteredClusters =
      clusters?.filter((c) => branchIds.includes(c.branch_id)) ?? [];
    newSelection.clusters =
      type === "clusters" ? data : filteredClusters.map((c) => c.name);

    const clusterIds = getIds(clusters!, newSelection.clusters);
    const filteredCities =
      cities?.filter((ct) => clusterIds.includes(ct.cluster_id)) ?? [];
    newSelection.cities =
      type === "cities" ? data : filteredCities.map((c) => c.name);

    setSelection(newSelection);
  };

  if (status == "loading")
    return (
      <div className="grid lg:grid-cols-5 gap-4">
        {Array.from({ length: 5 }).map((_, i) => (
          <div key={i} className="h-[320px] skeleton w-full"></div>
        ))}
      </div>
    );
  return (
    <div className="grid lg:grid-cols-5 gap-4">
      <Selection
        data={areas!}
        name="area"
        selected={selection.areas}
        handleSelection={(data) => handleSelect("areas", data)}
      />
      <Selection
        data={regions!}
        name="region"
        selected={selection.regions}
        handleSelection={(data) => handleSelect("regions", data)}
      />
      <Selection
        data={branches!}
        name="branch"
        selected={selection.branches}
        handleSelection={(data) => handleSelect("branches", data)}
      />
      <Selection
        data={clusters!}
        name="cluster"
        selected={selection.clusters}
        handleSelection={(data) => handleSelect("clusters", data)}
      />
      <Selection
        data={cities!}
        name="city"
        selected={selection.cities}
        handleSelection={(data) => handleSelect("cities", data)}
      />
    </div>
  );
};

export default FormEligibilityTerritory;
